import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { useState } from 'react';
import ImageListItem from '@mui/material/ImageListItem';
import CommonForm from './CommonForm';
import recovery from '../../assets/gifs/accountRecovery.gif';
import { useErrorHandler } from 'react-error-boundary';
import { useDispatch } from 'react-redux';
import { sendResetRequest } from '../../redux/actions/CandidateRecoveryAction';
import { useNavigate } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
    paperStyle: {
        boxShadow: '0px 6px 22px rgba(0, 0, 0, 0.08)',
        width: '80%',
        margin: 0,
        paddingBottom: 48,
    },
}));
const AccountRecovery = () => {
    const classes = useStyles();
    const [credentials, setCredentials] = useState({ email: '', userName: '' });
    const [validator, setValidator] = useState({ inputOne: '' });
    const errorHandler = useErrorHandler();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleFormEdit = (event) => {
        setValidator({});
        const { name, value } = event.target;
        setCredentials({
            ...credentials,
            [name]: value,
        });
    };
    const checkEmailErrors = () => {
        let emailRegex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
        if (!emailRegex.test(credentials.email)) {
            setValidator({ inputOne: 'Invalid Email' });
            return false;
        }

        return true;
    };
    const handleResetReq = () => {
        try {
            if (checkEmailErrors()) {
                const details = { email: credentials?.email };
                dispatch(sendResetRequest(details));
                setTimeout(() => {
                    navigate('/login'); 
                }, 2000);
            }
        } catch (error) {
            errorHandler(error);
        }
    };
    const recoveryProps = {
        id: 2,
        formHeading: 'Account Recovery',
        formSubHeading: 'This helps show that this account really belongs to you.',
        inputOneData: {
            label: 'Email',
            type: 'email',
            name: 'email',
            value: credentials.email,
            onChange: handleFormEdit,
        },

        buttonName: "Yes, it's me !",
        customStyle: classes.paperStyle,
    };
    return (
        <Grid container>
            <Grid item  sm={6} xs={12} textAlign='center'>
                <ImageListItem>
                    <img alt='Login' src={recovery}></img>
                </ImageListItem>
            </Grid>
            <Grid item container sm={6} xs={12}>
                <Grid item sm={2}></Grid>
                <Grid item container sm={10}>
                    <CommonForm
                        {...recoveryProps}
                        validator={validator}
                        onClick={handleResetReq}></CommonForm>
                </Grid>
                <Grid item sm={2}></Grid>
            </Grid>
        </Grid>
    );
};

export default AccountRecovery;
